import script from "./LocaleSuggestion.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleSuggestion.vue?vue&type=script&setup=true&lang=js"

import "./LocaleSuggestion.vue?vue&type=style&index=0&id=a1fc6272&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1fc6272"]])

export default __exports__